var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticStyle: { overflow: "hidden" } },
    [
      _c(
        "v-toolbar",
        { attrs: { flat: "", dense: "", color: "secondary", dark: "" } },
        [
          _c("v-toolbar-title", { staticClass: "body-2" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm.dateRangeEditable
            ? _c(
                "v-btn-toggle",
                {
                  staticClass: "date-range-toggle",
                  attrs: { mandatory: "" },
                  model: {
                    value: _vm.selectedDateRange,
                    callback: function ($$v) {
                      _vm.selectedDateRange = $$v
                    },
                    expression: "selectedDateRange",
                  },
                },
                _vm._l(_vm.dateRangeShortcuts, function (item, idx) {
                  return _c(
                    "v-btn",
                    {
                      key: idx,
                      staticClass: "text-capitalize",
                      attrs: {
                        flat: "",
                        small: "",
                        value: item.value,
                        title: item.label,
                      },
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(item.shortLabel) + "\n      "
                      ),
                    ]
                  )
                }),
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { staticClass: "pa-2", attrs: { wrap: "" } },
        _vm._l(_vm.children, function (child, idx) {
          return _c(
            "v-flex",
            _vm._b(
              { key: idx, staticClass: "pa-2" },
              "v-flex",
              _vm.childFlexProps,
              false
            ),
            [
              _c("TimeSeriesGraphWidget", {
                ref: "childWidgets",
                refInFor: true,
                attrs: {
                  "widget-id": `${_vm.widgetId}-${idx}`,
                  config: child,
                  "global-date-range": _vm.selectedDateRange,
                },
              }),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }